import { IMAGES } from "@/assets/IMAGES";
import "./landing-page.css";
import { useLocation, useNavigate } from "react-router-dom";
import CommonButton from "@/components/custom-component/CommonButton";
import { Card } from "@/components/ui/Card";
import { getLinks } from "@/utils/Helper";
import React, { useEffect, useState } from "react";
import { Divider } from "@/components/ui/divider";
import { Send } from "lucide-react";
import { useToast } from "@/components/ui/UseToast";

const LandingPage = () => {
  const navigate = useNavigate();
  const links = getLinks() || ["/"]; // Return landing page as default;
  const isAuthenticated = Boolean(localStorage.getItem("userToken"));
  const userPersona = localStorage.getItem("userType");
  const location = useLocation();
  const {toast} = useToast();

  const [its, setIts] = useState<string>("");

  useEffect(() => {
    if (
      isAuthenticated &&
      userPersona === "Admin" &&
      location.pathname === "/"
    ) {
      navigate(links[0]);
    } else if (
      isAuthenticated &&
      userPersona === "RemoteUser" &&
      location.pathname === "/"
    ) {
      navigate("/user/home");
    }
  }, [location]);

  function handleCheckAppointment() {
    if (!(its && its.length == 8 && /^\d+$/.test(its))) { 
      toast({
        variant: "destructive",
        description: "Please enter ITS",
      });
      return;
    }

    navigate(`/check_my_tickets/${its}`)
  }

  return (
    <div className="LandingPage-main flex h-screen items-center px-4 sm:px-8 md:px-12 lg:px-16">
      {/* <div className="flex w-full max-w-lg flex-col items-start justify-center p-4 md:max-w-xl lg:max-w-2xl lg:pl-14"> */}
      <Card className="px-16 max-w-md bg-transparent border-none  p-2">
        <div className="mb-4 flex items-center gap-2  ">
          <img
            src={IMAGES?.logo_icon}
            alt="Logo"
            className=" h-[8rem]  w-auto object-contain"
          />
          <p className="text-white font-bold text-[2rem] tracking-wider md:text-[2rem] lg:text-[2rem]">
            QMS
          </p>
        </div>
        <h1 className="mt-2 text-[1rem] font-semibold italic text-white sm:text-xl lg:text-2xl md:text-2xl">
          CONNECTING PEOPLE TO SERVICES
        </h1>

        <p className="mt-4 text-[.8rem] text-white font-light sm:text-base lg:text-lg md:text-2xl md:text-[1.4rem] ">
          We help our clients create truly excellent customer and employee
          experiences as well as smoother, more efficient operations – every day
          and all around the world.
        </p>
        <div className="mt-4 w-full flex items-center flex-col justify-center gap-2">
          <div className="mt-4 w-full flex items-center">
            {/* <CommonButton
              title="Login as Admin"
              className="text-nowrap"
              onClick={() => navigate("/login")}
            /> */}
            <CommonButton
              title="Login"
              className="text-nowrap flex-1"
              onClick={() => navigate("/user-login")}
            />
          </div>
          <div className="flex justify-center items-center">
            <Divider text="Or" />
          </div>
          <div className="w-[100%] flex items-start gap-1 flex-col flex-2">
            <h1 className="ml-1 mt-2 text-[1rem] font-semibold text-white text-opacity-95 sm:text-xl lg:text-xl md:text-2xl">
              CHECK YOUR APPOINMENTS
            </h1>
            <div
              className={`flex items-center bg-[#373737] bg-opacity-40 custom-box-shadow w-full gap-2 px-4 py-2 rounded-md border border-checkboxborder focus-within:outline-none focus-within:ring-2 focus-within:ring-white`}>
              <input
                maxLength={50}
                id="identifier"
                type="text"
                placeholder="Enter your 8-digit ITS ID"
                className={`w-full bg-transparent border-checkboxborder text-textgray outline-none`}
                value={its}
                onChange={(e) => setIts(e.target.value)}
              />
              <CommonButton
                title={<Send className="h-5 w-5 text-white group-hover:text-primary disabled:cursor-not-allowed disabled:opacity-70" />}
                className="text-nowrap flex-1 group"
                onClick={handleCheckAppointment}
                disabled={!(its && its.length == 8 && /^\d+$/.test(its))}
              />
            </div>
          </div> 
        </div>
      </Card>
      {/* </div> */}
    </div>
  );
};
export default LandingPage;
